import React, { Fragment, Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import "./InvitationModal.scss";
import InfoCircleIcon from "../../../../global/img/InfoCircleIcon";

Modal.setAppElement("#root");

class InvitationModal extends Component {
  constructor(props) {
    super(props);

    this.getHeaders = this.getHeaders.bind(this);
    this.getInfo = this.getInfo.bind(this);
    this.getButtons = this.getButtons.bind(this);
  }

  getHeaders() {
    let display = {};
    if (this.props.view === "accept") {
      display.header =
        "You are about to join the network " + this.props.legalBusinessName;
      display.subheader = "Are you sure you want to continue?";
    } else if (this.props.view === "decline") {
      display.header =
        "You are about to decline " +
        this.props.senderGivenName +
        " " +
        this.props.senderFamilyName +
        "'s invitation to join " +
        this.props.legalBusinessName;
      display.subheader = "Are you sure you want to continue?";
    } else if (this.props.view === "Accepted") {
      display.header =
        "You are now a member of " + this.props.legalBusinessName;
      display.subheader =
        "You can now use your network's profiles to prefill forms. " +
        "Your cases will now be shared with your network's admin(s).";
    } else if (this.props.view === "Rejected") {
      display.header =
        "You have declined " +
        this.props.senderGivenName +
        " " +
        this.props.senderFamilyName +
        "'s invitation to join " +
        this.props.legalBusinessName;
      display.subheader =
        'Return to "My Network" to respond to additional network invites ' +
        "or start your own network by inviting others to join.";
    }

    return display;
  }

  getInfo() {
    if (this.props.view === "accept") {
      return (
        <div>
          <div className="invitation-info-buffer">
            <span className="invitation-icon">
              <InfoCircleIcon color={"#55575b"} />
            </span>
            <span className="invitation-info">
              By accepting this invitation, your existing cases and profiles
              will be added to the network.
            </span>
          </div>
          <div>
            <span className="invitation-icon">
              <InfoCircleIcon color={"#55575b"} />
            </span>
            <span className="invitation-info">
              By accepting this invitation, your account permissions will be set
              by the master account holder.
            </span>
          </div>
        </div>
      );
    } else if (this.props.view === "decline") {
      return (
        <div>
          <div className="invitation-info-buffer">
            <span className="invitation-icon">
              <InfoCircleIcon color={"#55575b"} />
            </span>
            <span className="invitation-info">
              By declining, you will not join this network and the invitation
              will be removed from your list of network invitations.
            </span>
          </div>
        </div>
      );
    } else if (this.props.view === "Accepted") {
      return (
        <div>
          <div className="invitation-info-buffer">
            <span className="invitation-icon">
              <InfoCircleIcon color={"#55575b"} />
            </span>
            <span className="invitation-info">
              If you accepted this invitation by mistake, ask the inviter to
              remove you from the network.
            </span>
          </div>
        </div>
      );
    } else if (this.props.view === "Rejected") {
      return (
        <div>
          <div className="invitation-info-buffer">
            <span className="invitation-icon">
              <InfoCircleIcon color={"#55575b"} />
            </span>
            <span className="invitation-info">
              If you declined this invitation by mistake, ask the inviter to
              send a new invitation.
            </span>
          </div>
        </div>
      );
    }
  }

  getButtons() {
    if (this.props.view === "accept") {
      return (
        <div>
          <button
            className="usa-button usa-button--outline"
            onClick={() => {
              this.props.closeModal();
            }}
          >
            Close
          </button>
          <button
            className="usa-button accept-invitation-button"
            onClick={() => {
              this.props.updateInvitaiton("Accepted");
            }}
          >
            Accept & Continue
          </button>
        </div>
      );
    } else if (this.props.view === "decline") {
      return (
        <div>
          <button
            className="usa-button usa-button--outline"
            onClick={() => {
              this.props.closeModal();
            }}
          >
            Close
          </button>
          <button
            className="usa-button decline-invitation-inner-button"
            onClick={() => {
              this.props.updateInvitaiton("Rejected");
            }}
          >
            Decline Invitation
          </button>
        </div>
      );
    } else {
      return (
        <div>
          <button
            className="usa-button full-button"
            onClick={() => {
              this.props.closeModal();
            }}
          >
            Close
          </button>
        </div>
      );
    }
  }

  render() {
    let headers = this.getHeaders();

    return (
      <Fragment>
        <Modal
          isOpen={this.props.showModal}
          contentLabel="invitationModal"
          onRequestClose={this.props.closeModal}
          className="Modal modal-padding"
          overlayClassName="Overlay"
        >
          <div id="invitation-modal">
            <div id="invitation-modal-inner">
              <h3>{headers.header}</h3>
              <h4>{headers.subheader}</h4>
              <div className="invitation-modal-body">
                <div>{this.getInfo()}</div>
              </div>
            </div>
            <div id="page-footer">
              <div>{this.getButtons()}</div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

const mapStateToProps = (state, ownProps) => {
  const senderGivenName = ownProps.invitation.firstName
    ? ownProps.invitation.firstName
    : "N/A";
  const senderFamilyName = ownProps.invitation.lastName
    ? ownProps.invitation.lastName
    : "N/A";
  const legalBusinessName = ownProps.invitation.legalBusinesName
    ? ownProps.invitation.legalBusinesName
    : "N/A";
  return {
    showModal: ownProps.showModal,
    view: ownProps.view,
    closeModal: ownProps.closeModal,
    updateInvitation: ownProps.updateInvitation,
    invitation: ownProps.invitation,
    senderGivenName: senderGivenName,
    senderFamilyName: senderFamilyName,
    legalBusinessName: legalBusinessName,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvitationModal);
